import { combineReducers } from 'redux';
import user from './accountReducer';
import taskListState from './locationTaskListReducer';
import windowReducer from './windowReducer';
import navInfo from './navigationReducer';
import reports from './reportsReducer';
import projects from './projectsReducer';
import logout from './logoutReducer';
import { reducer } from 'redux-refresh-token';

const rootReducer = combineReducers({
    tokenRefresh: reducer,
    user,
    taskListState,
    window: windowReducer,
    navInfo,
    reports,
    projects,
    logout,
});

export default function createRootReducer() {
    return rootReducer;
}
